import React from 'react'
import { SectionTitleSkeleton } from '@diversioteam/diversio-ds'
import { Skeleton } from '@material-ui/lab'

import * as S from './../participationRate.styles'

export const ParticipationRateSkeleton = () => {
    return (
        <S.ParticipationWrapper>
            <SectionTitleSkeleton />

            <S.Content>
                <S.Count>
                    <Skeleton width={80} />
                </S.Count>

                <S.Description>
                    <Skeleton width={120} />
                </S.Description>
            </S.Content>
        </S.ParticipationWrapper>
    )
}
